export var WorkspaceStatus;
(function (WorkspaceStatus) {
    WorkspaceStatus["WORKSPACE_STATUS_PROVISIONING"] = "PROVISIONING";
    WorkspaceStatus["WORKSPACE_STATUS_ACTIVE"] = "ACTIVE";
    WorkspaceStatus["WORKSPACE_STATUS_FAILED"] = "FAILED";
    WorkspaceStatus["WORKSPACE_STATUS_DELETING"] = "DELETING";
    WorkspaceStatus["WORKSPACE_STATUS_DELETED"] = "DELETED";
})(WorkspaceStatus || (WorkspaceStatus = {}));
